export default {
  // Single-word names will no longer be used,
  // grandfathering this due current usage across the codebase
  name: 'SEO',
  description: 'Schema.org metadata in JSON-LD for SSR pages.',
  release: '0.2.2',
  functional: true,
  props: {
    schema: Object
  },
  render (h, { props }) {
    if (!props.schema) return
    return h('script', {
      attrs: { type: 'application/ld+json' },
      domProps: {
        innerHTML: JSON.stringify(props.schema)
      }
    })
  }
}
